module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-percentage-9fcf537ecce4769f84c70d9010050fe0.svg";